import { getTemplatesColumns } from '@/modules/drivers/constants/tables'
import { useTable } from '@/modules/drivers/context/TableContext'
import { useSortableData } from '@/modules/drivers/hooks/useSortTable'
import { TableHeader } from '@/modules/drivers/shared/tableItems/TableHeader'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React, { useEffect } from 'react'
import TemplateRowItem from './TemplateRowItem'

const TemplatesTable = ({
  templates,
  setSelectedTemplateId,
  setSelectedContractIdFromTemplate,
  onDelete,
}) => {
  const { t } = useLocalize()
  const columns = getTemplatesColumns(t)
  const { toggleAll, toggleId, retainIds, selectedGroup, isSelectedAny } =
    useTable()
  const { sortedData, sortConfig, handleHeaderClick, setSortConfig } =
    useSortableData({
      data: templates,
      tableColumns: columns,
    })

  useEffect(() => {
    retainIds(templates.map((template) => template.templateId))
  }, [templates, retainIds])

  useEffect(() => {
    setSelectedTemplateId(selectedGroup?.ids[0]?.toString() ?? null)
    setSelectedContractIdFromTemplate(
      templates.find((template) => template.templateId === selectedGroup?.ids[0])
        ?.contract?.id ?? null,
    )
  }, [selectedGroup])
  return (
    <div className={`tw-overflow-x-auto`}>
      <table className="tw-min-w-full tw-table-auto tw-border-collapse">
        <TableHeader
          columns={columns}
          fontSize="md"
          isSelectedAny={isSelectedAny}
          sortConfig={sortConfig}
          bolder
          rounded={false}
          disabledToggle
          toggleAll={toggleAll}
          onHeaderClick={handleHeaderClick}
        />
        <tbody className="tw-relative">
          {sortedData &&
            sortedData.map((template, i) => (
              <TemplateRowItem
                key={template.templateId}
                selectedIds={selectedGroup?.ids ?? []}
                template={template}
                toggleId={toggleId}
                onDelete={onDelete}
              />
            ))}
        </tbody>
      </table>
    </div>
  )
}

export default TemplatesTable
